// extracted by mini-css-extract-plugin
module.exports = {"background":"i_A"};